import { format } from "date-fns";

import { QUERY_KEYS } from "../../../../constants/queryKeys";
import { getCheckedPrefectureCodeList } from "../getCheckedPrefectureCodeList";

import type {
  CommonConditionsState,
  State,
} from "../useFormState/types/states";

const {
  AVAILABILITY_STATUS,
  END_DATE,
  EVENT_TYPE,
  GENRE,
  KEYWORD,
  PREFECTURES,
  START_DATE,
} = QUERY_KEYS.SEARCH_CONDITIONS;

type Input = State & {
  keyword: string;
  search: string;
};
type Output = string;
type GetNextQuery = (input: Input) => Output;

const formatForDate = (date: Date) => format(date, "yyyy-MM-dd");
const extractChecked = (items: CommonConditionsState["checkboxData"]) =>
  items
    .filter(({ isChecked }) => isChecked)
    .map(({ checkboxId }) => checkboxId);

export const getNextQuery: GetNextQuery = (input) => {
  const {
    availabilityStatus,
    endDate,
    eventType,
    genre,
    keyword,
    prefectures,
    search,
    startDate,
  } = input;

  const parameters = new URLSearchParams(search);
  const conditionKeys = Object.values(QUERY_KEYS.SEARCH_CONDITIONS);
  conditionKeys.forEach((key) => {
    parameters.delete(key);
  });
  if (keyword !== "") {
    parameters.set(KEYWORD, keyword);
  }
  if (startDate !== undefined) {
    parameters.set(START_DATE, formatForDate(startDate));
  }
  if (endDate !== undefined) {
    parameters.set(END_DATE, formatForDate(endDate));
  }
  const checkedGenre = extractChecked(genre.checkboxData);
  checkedGenre.forEach((genre) => {
    parameters.append(GENRE, genre);
  });
  const checkedEventType = extractChecked(eventType.checkboxData);
  checkedEventType.forEach((eventType) => {
    parameters.append(EVENT_TYPE, eventType);
  });
  const checkedAvailabilityStatus = extractChecked(
    availabilityStatus.checkboxData
  );
  checkedAvailabilityStatus.forEach((availabilityStatus) => {
    parameters.append(AVAILABILITY_STATUS, availabilityStatus);
  });
  const checkedPrefectureCodeList = getCheckedPrefectureCodeList(prefectures);
  checkedPrefectureCodeList.forEach((prefectureCode) => {
    parameters.append(PREFECTURES, prefectureCode);
  });

  return parameters.toString();
};
